<div id="header">
  <app-message></app-message>
  <div id="header-title">
    <h1>Aztalena</h1>
    <p>Description about the website</p>
  </div>
  <div>
    @if (!isSignedIn) {
      <button mat-raised-button routerLink="/sign-in" class="button-sign-up">ลงชื่อเข้าใช้</button>
    }
    @if (!isSignedIn) {
      <button mat-raised-button routerLink="/sign-up" class="button-sign-up">สมัครสมาชิก</button>
    }
    @if (isSignedIn) {
      <button mat-raised-button routerLink="/user/setup" class="button-sign-up">
        Select Tribe
      </button>
    }
  </div>
</div>
